import React, { createContext, useState, useContext } from 'react';

const SessionContext = createContext({
  isSessionExpired: false,
  setSessionExpired: (expired: boolean) => {},
});

export const useSessionExpiration = () => useContext(SessionContext);

export const SessionExpirationProvider = ({ children }: { children: React.ReactNode }) => {
  const [isSessionExpired, setIsSessionExpired] = useState(false);

  return (
    <SessionContext.Provider value={{ isSessionExpired, setSessionExpired: setIsSessionExpired }}>
      {children}
    </SessionContext.Provider>
  );
};